import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import './Impressum.css';

const Impressum = () => {
  return (
    <>
      <Navigation />
      <div className="impressum-page">
      <div className="impressum-container">
        <div className="impressum-content">
          <h1>Impressum</h1>
          
          <section className="impressum-section">
            <h2>Angaben gemäß § 5 TMG</h2>
            <div className="impressum-info">
              <p>SK Dienstleistungen  Inh. Andrada Simion</p>
              <p>Adalbert-Stifter Str. 4</p>
              <p>88131 Lindau (Bodensee)</p>
            </div>
          </section>

          <section className="impressum-section">
            <h2>Kontakt</h2>
            <div className="impressum-info">
              <p>0172 5443697</p>
              <p>E-Mail: info@dienstleistungensk.de</p>
            </div>
          </section>

          <section className="impressum-section">
            <h2>Umsatzsteuer-ID</h2>
            <div className="impressum-info">
              <p>DE402894832</p>
            </div>
          </section>

          <section className="impressum-section">
            <h2>Verbraucherstreitbeilegung</h2>
            <div className="impressum-info">
              <p>
                Wir sind nicht bereit oder verpflichtet, ein Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle zu betreiben.
              </p>
            </div>
          </section>

          <div className="impressum-source">
            <p>
              Quelle: <a href="https://www.e-recht24.de/impressum-generator" target="_blank" rel="noopener noreferrer">https://www.e-recht24.de/impressum-generator</a>
            </p>
          </div>

          <div className="impressum-back">
            <Link to="/" className="btn btn-secondary">
              <i className="fas fa-arrow-left"></i> Zurück zur Startseite
            </Link>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default Impressum;

